import Button from '@/components/UI/Button';
import Icon from '@/components/Unistyles/Icon';

export default function PeopleRowActions({
  name,
  onEdit,
  size = 'sm',
}: {
  name: string;
  onEdit: () => void;
  size?: 'sm' | 'md' | 'lg';
}) {
  return (
    <Button
      appearance="ghost"
      iconOnly
      size={size}
      accessibilityLabel={`Manage membership for ${name}`}
      onPress={(event) => {
        event.stopPropagation();
        onEdit();
      }}
    >
      <Icon name="ellipsis-horizontal" variant="typographySecondary" />
    </Button>
  );
}
